import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { API_BASE } from '../lib/api-base';

const AuthContext = createContext(null);
const API = API_BASE;

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const token = localStorage.getItem('ees_token');
      const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
      const res = await fetch(`${API}/api/auth/me`, { credentials: 'include', headers });
      if (res.ok) { setUser(await res.json()); } else { localStorage.removeItem('ees_token'); setUser(null); }
    } catch { setUser(null); }
    setLoading(false);
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const login = async (email, password) => {
    const res = await fetch(`${API}/api/auth/login`, {
      method: 'POST', credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });
    if (!res.ok) { const e = await res.json(); throw new Error(e.detail || 'Login fehlgeschlagen'); }
    const data = await res.json();
    if (data.token) localStorage.setItem('ees_token', data.token);
    setUser(data);
    // Safety net: falls /api/auth/login (Legacy) noch keine `actions`
    // liefert, /api/auth/me holen — sonst stehen Rechte erst nach
    // Page-Reload zur Verfügung.
    if (!data.actions) {
      try { await checkAuth(); } catch { /* ignore */ }
    }
    return data;
  };

  const logout = async () => {
    await fetch(`${API}/api/auth/logout`, { method: 'POST', credentials: 'include' });
    localStorage.removeItem('ees_token');
    setUser(null);
  };

  return <AuthContext.Provider value={{ user, loading, login, logout, checkAuth }}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
